(function () {
  angular.module("akitabox.ui.dialogs.alert", [
    "ngMaterial",
    "akitabox.core.toast",
  ]);
})();
